import { ProductType } from '../../common/models/product-type.model';
import {
  SET_PRODUCT_TYPES,
  SET_PRODUCT_TYPES_LOADING,
  SET_PRODUCT_TYPES_ERROR,
  SET_ACTIVE_TYPE,
  ADD_PRODUCT_TYPE,
  UPDATE_PRODUCT_TYPE,
  DELETE_PRODUCT_TYPE,
} from './productTypesActionTypes';

export const setProductTypes = (types: ProductType[]) => ({
  type: SET_PRODUCT_TYPES,
  payload: types,
});

export const setProductTypesLoading = (loading: boolean) => ({
  type: SET_PRODUCT_TYPES_LOADING,
  payload: loading,
});

export const setProductTypesError = (error: string | null) => ({
  type: SET_PRODUCT_TYPES_ERROR,
  payload: error,
});

export const setActiveType = (productType: ProductType | null) => ({
  type: SET_ACTIVE_TYPE,
  payload: productType,
});

export const addProductType = (productType: ProductType) => ({
  type: ADD_PRODUCT_TYPE,
  payload: productType,
});

export const updateProductType = (productType: ProductType) => ({
  type: UPDATE_PRODUCT_TYPE,
  payload: productType,
});

export const deleteProductType = (typeId: string) => ({
  type: DELETE_PRODUCT_TYPE,
  payload: typeId,
});
